import styled from 'styled-components'

export const CompareSlider = styled.div`
  a {
    text-decoration: none;
  }

  .slider-container-outer {
    display: block;
    position: relative;
    overflow: hidden;
    min-height: 500px;

    .slider-container-inner {
      display: block;
      position: relative;
      transition: left 0.5s;
      height: auto;
      overflow: hidden;

      .slider-item {
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
        width: 100%;
        height: 100%;
        //padding-right: 15px;

        .error-message {
          max-width: inherit;
          padding: 0 15px;

          > div {
            display: inline-block;
            height: fit-content;
            width: 97%;

            > button {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
`
